import { Ref, ref } from "@vue/composition-api";
import { RiskyUsersPolicyL0StatusItem } from "./model";
import * as api from "./api";
import { UseLoading } from "@/common/composition/loading";
import { SharedState } from "@/common/state";
import { InfoTypeHelper } from "@/common/models";

const [is_loading, set_loading] = UseLoading(false).as_arr();

const status_list: Ref<RiskyUsersPolicyL0StatusItem[]> = ref([]);

const get_risky_users_counts = async (): Promise<Record<string, number>> => {
  const res = await Promise.all(
    SharedState.l0InfoTypes.value.map(({ id }) => {
      return api.get_risky_users_count_for_l0({
        l0_id: id,
        date: SharedState.get_last_week_time_frame().from,
        frame: "Week",
      });
    })
  );
  return res.reduce((acc, item) => {
    if (item.success) {
      acc[item.value.id] = item.value.count;
    }
    return acc;
  }, {} as Record<string, number>);
};

const load_status_list = async () => {
  set_loading(true);
  const res = await api.get_risky_users_status_list();
  const counts = await get_risky_users_counts();
  console.log("users counts:", counts);
  if (res.success) {
    status_list.value = res.value
      .filter((f) => f.id !== InfoTypeHelper.REGULATED_ID())
      .map((val) => {
        return {
          ...val,
          approx_count: counts[val.id] || 0,
        };
      });
  }
  set_loading(false);
};

const toggle_item_activity_state = async (item_id: string) => {
  set_loading(true);
  const item = status_list.value.find((f) => f.id === item_id);
  if (item) {
    const res = await api.toggle_l0_risky_user_active_status({
      id: item.id,
      activate: !item.is_active,
      selected_percentage: item.detect_percentage,
    });
    if (res.success) {
      status_list.value = status_list.value.map((d) => {
        if (d.id === item_id) {
          return {
            ...d,
            is_active: !d.is_active,
          };
        }
        return d;
      });
    }
  }
  set_loading(false);
};

const update_policy_level = async (item_id: string, level: number) => {
  set_loading(true);
  const item = status_list.value.find((f) => f.id === item_id);
  if (item) {
    const res = await api.toggle_l0_risky_user_active_status({
      id: item.id,
      activate: item.is_active,
      selected_percentage: level,
    });
    if (res.success) {
      status_list.value = status_list.value.map((d) => {
        if (d.id === item_id) {
          return {
            ...d,
            detect_percentage: level,
          };
        }
        return d;
      });
    }
  }
  set_loading(false);
};

const init = async () => {
  await load_status_list();
};

export const state = {
  init,
  is_loading,
  status_list,
  toggle_item_activity_state,
  update_policy_level,
};
